import Link from "next/link";
import Typography from "@mui/material/Typography";


// ==============================================================


// ==============================================================

export default function ProductTitle({
  title,
  slug
}) {
  return <Link prefetch={false} href={`/products/${slug}`}>
      <Typography     sx={{
          maxWidth: '220px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
      }} noWrap variant="h6" className="title" color="textSecondary">
        {title}
      </Typography>
    </Link>;
}